import { useEffect, useState } from 'react';
import { get, post } from '../../../Services/api'
import WeightChart from './Chart';
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format';
import arrow_up from '../../../resources/arrow-up.svg'
import arrow_down from '../../../resources/arrow-down.svg'
import './weight.css'
import edit_icon from '../../../resources/edit 1.png'

function AnalyticsWeight({ currentUser }) {
    const [weight, setWeight] = useState([]);
    const today = yyyy_mm_dd_date_format({})
    const [timeFrame, setTimeFrame] = useState('week')
    const [percentIncrease, setPercentIncrease] = useState(0)
    const [unit, setUnit] = useState()

    const [weightChange, setWeightChange] = useState()
    const [unitChange, setUnitChange] = useState()
    const [edit, setEdit] = useState(false)



    useEffect(() => {
        // Weight Stats
        get_weight_stat()
    }, [timeFrame])

    async function get_weight_stat() {
        const resp = await get("/api/analytics/get-weight-history", {
            user_id: currentUser.uid,
            date: today,
            time_frame: timeFrame
        })

        // Set weight
        setWeight(resp.weights)
        // set unit
        setUnit(resp.unit)
        // set percentage change
        setPercentIncrease(resp.percent_change)
    }

    async function saveWeightInfo() {
        try {
            await post("/api/analytics/update-weight", {
                user_id: currentUser.uid,
                date: today,
                weight: weightChange,
                unit: unitChange
            })

            get_weight_stat()

            // close editting
            setEdit(false);
        } catch (error) {
            console.log(error)
            // close editting
            setEdit(false);
            setWeightChange(weight[weight.length - 1].data.calculate_current_weight);
            setUnitChange(unit);
        }
    }

    return (
        <div className='component_padding black'>
            <div className='dashboard-intake-overview-heading flex align_center justify_space_between'>
                <h4 className='font_family_ovo no_margin'>Weight Overview</h4>

                <div className="dashboard-intake-overview-range-picker-div">
                    <select className='dashboard-intake-overview-range-picker gray_scale_2' onChange={(e) => setTimeFrame(e.target.value)}>
                        <option value={'week'}>Last Week</option>
                        <option value={'month'}>Last 28 Days</option>
                        <option value={'year'}>Last 1 Year</option>
                    </select>
                    <svg
                        className="ashboard-intake-overview-range-picker-custom-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="none"
                        stroke="#5A5855"
                        strokeWidth="2"
                    >
                        <polyline points="5,7 10,12 15,7" />
                    </svg>
                </div>
            </div>

            <div className='component_heading_separating_line'></div>

            <div className='position_relative flex align_center gap_8'>
                {(edit && weightChange) ?
                    <div className='flex gap_10 align_center'>
                        <input type="number" value={parseInt(weightChange)}
                            onChange={(e) => setWeightChange(!e.target.value || e.target.value < 0 ? 0 : (e.target.value < 1000 ? e.target.value : 999))}
                            style={{ width: `${parseInt(weightChange).toString().length}ch` }}
                            className='analytics-weight-set-input font_family_ovo no_margin font_size_50 analytics-current-weight-p' />

                        <select onChange={(e) => setUnitChange(e.target.value)} className='analytics-weight-unit-select gray_gradient font_size_30 font_family_inter'>
                            <option value='lbs' selected={unit === 'lbs'}>lbs</option>
                            <option value='kg' selected={unit === 'kg'}>kg</option>
                        </select>
                    </div>
                    :
                    <p className='font_family_ovo font_size_50 analytics-current-weight-p'>{weight.length ? weight[weight.length - 1].data.calculate_current_weight : null} <span className='font_weight_600 font_family_inter font_size_30 gray_scale_3'>{unit}</span></p>
                }

                <div className='analytics-weight-edit-div' >
                    {edit ?
                        <div className='flex flex_column gap_8 align_center'>
                            <button onClick={saveWeightInfo} className="analytics-weight-edit-save green_gradient white font_weight_600 cursor_pointer">Save</button>

                            {/* <p className='cursor_pointer' onClick={saveWeightInfo}>Save</p> */}
                            <p className='cursor_pointer' onClick={() => { setEdit(false); setWeightChange(weight[weight.length - 1].data.calculate_current_weight); setUnitChange(unit) }}>Cancel</p>
                        </div>
                        : <img className='cursor_pointer' src={edit_icon} width={25} onClick={() => setEdit(true)} />
                    }
                </div>



                {!edit ?
                    <div className={(percentIncrease == 0 ? 'weight-constant-div' : (percentIncrease < 0 ? 'weight-decrease-div' : 'weight-increase-div')) + ' analytics-current-weight-percent-increase-div flex align_center'}>
                        {percentIncrease != 0 ? <img width={15} src={percentIncrease < 0 ? arrow_down : arrow_up} className={percentIncrease < 0 ? 'weight-decrease-arrow' : ''} /> : null}
                        <p className={(percentIncrease == 0 ? 'weight-constant-p' : (percentIncrease < 0 ? 'weight-decrease-p' : 'weight-increase-p')) + ' font_weight_600'}>{Math.abs(percentIncrease)}%</p>
                    </div>
                    : null}
            </div>

            <WeightChart details={weight} />
        </div >
    );
}


export default AnalyticsWeight;